import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Row, Col, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import FilterByStart from '../Common/filterByStart';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { isCPG, isOLG, isVIP } from '../../actions/root_url';

const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

class RowRenderer extends Component {
  PropTypes: {
    onDoubleClick: React.PropTypes.func;
  }
  render() {
    return (
      <div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

class VendorBatches extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      filters: {},
      selectedRows: [],
      sortColumn: null,
      sortDirection: null,
      clickedCell: { row: 0, column: -1 },
    };
    this.onCellSelected = this.onCellSelected.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.selectVendorBatches = this.selectVendorBatches.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidMount() {
    if (this.refs["inventoryInfo"]) {
      ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    }
    // this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorBatches && nextProps.vendorBatches !== this.props.vendorBatches) {
      const rows = [...nextProps.vendorBatches];
      this.setState({ rows });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vendorBatches && prevProps.vendorBatches.length !== 0 && prevProps.vendorBatches !== this.props.vendorBatches) {
      ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    }
    // if( (!(prevProps.vendorBatches) || (prevProps.vendorBatches.length==0)) && this.props.vendorBatches && this.props.vendorBatches.length != 0) {
    //   ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    // }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  // handleFormSubmit(formProps) {
  // }

  onCellSelected(coordinates) {
    const clickedCell = {
      row: coordinates.rowIdx,
      column: coordinates.idx - 1, // because there is a checkbox column makes this 1 indexed, convert it to 0 indexed here
    };
    this.setState({ clickedCell });
  }

  onKeyDown(e) {
   if (e.keyCode === ENTER_KEY) {
      e.preventDefault();
      let rows = this.state.rows;
      let row = rows[this.state.clickedCell.row];
      this.selectProduct(row)
      // this.props.selectInventoryInfo(row);
      // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
      // this.props.closeShowInventory('allProd_Quantity');
    }
  }

  handleKeyDown(event) {
    switch(event.keyCode) {
      case ESCAPE_KEY:
        this.props.closeShowVendorBatches('allProducts');
        break;
      default:
        break;
    }
  }

  selectVendorBatches() {
    this.props.moveToProductsListFromVendor(this.state.selectedRows);
    this.props.closeShowVendorBatches();
  }


  selectProduct(product) {
    this.props.selectInventoryInfo(product);
    this.props.setAllProducts(`${product.ProductNum} | ${product.Name} | ${product.Description} | ${product.MeasureUnit}`, this.props.form );
    this.props.closeShowInventory('allProd_Quantity');
  }

  renderTable() {
    if (this.props.vendorBatchesIsLoading && !this.props.vendorBatchesError) return <Spinner />
    else if (this.props.vendorBatchesError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.vendorBatchesError)}</div></ContentWrapper>

    // Parameters of the react-data-grid
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    }

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    }

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    }

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      const selectedRows = [];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      newRows.map((r) => {
        if (r.isSelected === true) {
          selectedRows.push(r);
        }
      });
      this.setState({ rows: newRows, selectedRows });
    }

    // Handle the row select function
    const onRowsSelected = (rows) => {
      // const selectedRows = [];
      // const newRows = this.state.rows;
      const newRows = getRows();
      const selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      // newRows.map((r) => {
      //   if (r.isSelected === true) {
      //     selectedRows.push(r);
      //   }
      // });
      this.setState({ ...this.state, rows: newRows, selectedRows });
    };

    const onClearFilters = () => {
      // all filters removed
      this.setState({ filters: {} });
    };
    
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          let date = new Date(this.props.value)
          let index = dateMap.indexOf(date.toString().slice(4,3));
          let localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;;
        }
        else return <span className="label label-danger">-</span>;
      }
    });

    // Column difinition
    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 70,
        filterRenderer: FilterByStart,
      },
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 70,
        filterRenderer: FilterByStart,
      },
      {
        key: 'Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
        filterRenderer: FilterMultiKeyword,
      },
      {
        key: 'Description',
        name: <Translate value="desc" />,
        resizable: true,
        filterable: true,
        sortable: true,
        filterRenderer: FilterMultiKeyword,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        filterRenderer: FilterMultiKeyword,
      },
      {
        key: 'Batch_PONum',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        filterRenderer: FilterMultiKeyword,
      },
      {
        key: 'ExpireDate',
        name: <Translate value="expired_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
        width: 100,
      },
      {
        key: 'BinName',
        name: <Translate value="bin" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value, dependentValues }) => {
          let locationAry = [];
          if (dependentValues.ZoneName) {
            locationAry.push(dependentValues.ZoneName)
          }
          if (dependentValues.BinName) {
            locationAry.push(dependentValues.BinName)
          }
          if (dependentValues.SectionName) {
            locationAry.push(dependentValues.SectionName)
          }

          return (
            <div
            style={{width: '100%'}}
            > 
            {locationAry.join('-')}
            </div>
          )
        },
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'BinAmount',
        name: <Translate value="bin_amount" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'NetWeight',
        name: <Translate value="net_wt" />,
        resizable: true,
        sortable: true,
        width: 50,
      },
    ];
    if (isOLG) {
      columns.push({
        key: 'receive_date',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter
      })
    }

    if (isCPG || isVIP) {
      const vendorInvDate = {
        key: 'InvoiceDate',
        name: <Translate value="vendor_inv_date" />,
        resizable: true,
        sortable: true,
        formatter: DateFormatter,
        width: 100,
      };

      columns.splice(_.findIndex(columns, { key: 'ExpireDate' }), 0, vendorInvDate);
    }

    return (
      <Row style={{ marginTop: '-5px' }}>
        <Col sm={12}>
          <div id="VendorBatches-dataGrid1">
            <ReactDataGrid
              ref="inventoryInfo" 
              rowRenderer={<RowRenderer onDoubleClick={this.selectProduct} />}
              rowKey="Product_id"
              rowHeight={25}
              minHeight={580}
              onGridSort={handleGridSort}
              columns={columns}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableCellSelect={true}
              onGridKeyDown={this.onKeyDown}
              onCellSelected={this.onCellSelected}
              enableRowSelect="multi"
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected'
                },
              }}
            />
          </div>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <ContentWrapper>
        <Button onClick={() => { this.selectVendorBatches(); }}><em className="fa fa-plus" /></Button>
        { this.renderTable() }
      </ContentWrapper>
    );
  }
}

export default VendorBatches;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/vendorBatches.jsx